import type { ReactStoryblokComponent } from "types/storyblok";
import { Header, type ActionButtonProps, type HeaderProps } from "../../globalComponents/Header";

export const HeaderAdapter = ({
  blok: { headerLogo = "Airhelp", headerLinks = [] },
  extraParams,
}: ReactStoryblokComponent<HeaderProps>) => (
  <Header
    headerActionButton={extraParams?.headerActionButton as ActionButtonProps["activeButtonOption"]}
    headerLinks={headerLinks}
    headerLogo={headerLogo}
    sideMenuContent={extraParams?.sideMenuContent as string}
    topBannerText={extraParams?.topBannerText as string}
    topBannerButtonText={extraParams?.topBannerButtonText as string}
    hideFlagBox={extraParams?.hideFlagBox as boolean}
  />
);
